<app-sidebar></app-sidebar>
<main class="container-fluid">
  <section class="ng-content" #content>
    <ng-content></ng-content>
  </section>
  <app-pagination></app-pagination>
  <app-spinner *ngIf="isLoading"></app-spinner>
</main>
<app-footer></app-footer>
